import { WORKSPACE_PLAN } from '@/entities/workspace/workspace-constants';

export function getNudgeBannerContent(plan: WORKSPACE_PLAN, limit: number) {
  const variant = plan === WORKSPACE_PLAN.TRIAL ? 'upgrade' : 'sales';
  const limitText = Math.max(limit, 0).toLocaleString();

  return {
    title: 'Need room for more campaigns?',
    body: `This workspace can create up to ${limitText} campaigns on the current plan.`,
    supportingBody:
      variant === 'upgrade'
        ? 'Upgrade to Enterprise to add more campaigns and keep your work moving.'
        : "Talk to sales about expanding this workspace's campaign capacity.",
    variant,
    cta: variant === 'upgrade' ? 'Upgrade plan' : 'Talk to sales',
    href: '/workspace/$workspaceId/settings/plan',
  };
}
